"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _lcHttp = _interopRequireDefault(require("lc-http"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _main = _interopRequireDefault(require("./components/main"));
var _spinner = _interopRequireDefault(require("./components/loading/spinner"));
var _educator = _interopRequireDefault(require("./components/changeAmount/educator"));
var _productTypes = _interopRequireDefault(require("./utils/product-types"));
require("./pf-revisions.scss");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var isAdsProduct = function isAdsProduct(productType) {
  return [_productTypes.default.PRP, _productTypes.default.IF].includes(productType);
};
var isFixedRate = function isFixedRate(productType) {
  return productType === _productTypes.default.IL;
};
var isLCBProduct = function isLCBProduct(productType) {
  return [_productTypes.default.LCFRP, _productTypes.default.LCTNI].includes(productType);
};
var retrieveOffersBasedOnApplication = function retrieveOffersBasedOnApplication(offers, selectedProductType) {
  var filter;
  switch (selectedProductType) {
    case 'PRP':
    case 'IF':
      filter = isAdsProduct;
      break;
    case 'IL':
      filter = isFixedRate;
      break;
    case 'LCFRP':
    case 'LCTNI':
    default:
      filter = isLCBProduct;
      break;
  }
  var filteredOffers = offers.reduce(function (list, offer) {
    return filter(offer.product) ? [].concat((0, _toConsumableArray2.default)(list), [offer]) : list;
  }, []);
  return filteredOffers;
};
var getOffers = function getOffers(options) {
  var url = options.url,
    params = options.params,
    selectedProductType = options.selectedProductType;
  return _lcHttp.default.get(url, {
    params: params
  }).then(function (_ref) {
    var offerItems = _ref.data.offerItems;
    return retrieveOffersBasedOnApplication(offerItems, selectedProductType);
  }).catch(function () {
    return [];
  });
};
var submitHandler = function submitHandler(_ref2) {
  var url = _ref2.changePlanUrl,
    successUrl = _ref2.successUrl,
    failureUrl = _ref2.failureUrl;
  return function (options) {
    var data = options.params;
    _lcHttp.default.post(url, data).then(function () {
      window.location = successUrl;
    }).catch(function () {
      window.location = failureUrl;
    });
  };
};
var MedicalChangeAmount = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(MedicalChangeAmount, _Component);
  var _super = _createSuper(MedicalChangeAmount);
  function MedicalChangeAmount(props) {
    var _this;
    (0, _classCallCheck2.default)(this, MedicalChangeAmount);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchOffers", function (_ref3) {
      var changeAmount = _ref3.changeAmount,
        secClientId = _ref3.secClientId;
      var _this$props = _this.props,
        url = _this$props.fetchOffersUrl,
        _this$props$applicati = _this$props.application,
        applicationId = _this$props$applicati.id,
        productType = _this$props$applicati.productType;
      var options = {
        url: url,
        params: {
          changeAmount: changeAmount,
          applicationId: applicationId,
          secClientId: secClientId
        },
        selectedProductType: productType
      };
      return getOffers(options).then(function (offers) {
        return _this.setState({
          offers: offers
        });
      }).catch(console.log);
    });
    _this.state = {
      offers: null,
      hasFetchedBasedOnAppData: false
    };
    return _this;
  }
  (0, _createClass2.default)(MedicalChangeAmount, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;
      var _this$state = this.state,
        offers = _this$state.offers,
        hasFetchedBasedOnAppData = _this$state.hasFetchedBasedOnAppData;
      if (this.props.application && (!offers || offers.length === 0) && !hasFetchedBasedOnAppData) {
        var _this$props2 = this.props,
          url = _this$props2.fetchOffersUrl,
          _this$props2$applicat = _this$props2.application,
          loanAmount = _this$props2$applicat.loanAmount,
          applicationId = _this$props2$applicat.id,
          productType = _this$props2$applicat.productType;
        var options = {
          url: url,
          params: {
            changeAmount: parseInt(loanAmount, 10),
            applicationId: applicationId
          },
          selectedProductType: productType
        };
        return getOffers(options).then(function (offers) {
          return _this2.setState({
            offers: offers,
            hasFetchedBasedOnAppData: true
          });
        }).catch(function () {
          return _this2.setState({
            hasFetchedBasedOnAppData: true
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        application = _this$props3.application,
        changePlanUrl = _this$props3.changePlanUrl,
        addProvider = _this$props3.addProvider,
        removeProvider = _this$props3.removeProvider,
        payees = _this$props3.payees,
        user = _this$props3.user,
        onCancel = _this$props3.onCancel,
        constants = _this$props3.constants,
        disclosureContent = _this$props3.disclosureContent,
        maxPayeeCount = _this$props3.maxPayeeCount;
      var offers = this.state.offers;
      var isPracticeUser = user.isPracticeUser;
      var route = isPracticeUser ? 'dashboard' : 'patient_center';
      var submitRevisions = submitHandler({
        changePlanUrl: changePlanUrl,
        successUrl: "/patientsolutions/".concat(route, "?changeamountcall=success"),
        failureUrl: "/patientsolutions/".concat(route, "?changeamountcall=failure")
      });
      var actions = {
        fetchOffers: this.fetchOffers,
        submitRevisions: submitRevisions
      };
      if (application && offers) {
        return /*#__PURE__*/_react.default.createElement(_main.default, {
          maxPayeeCount: maxPayeeCount,
          onCancel: onCancel,
          application: application,
          offers: offers,
          actions: actions,
          payees: payees,
          removeProvider: removeProvider,
          addProvider: addProvider,
          constants: constants,
          disclosureContent: disclosureContent
        });
      }
      return /*#__PURE__*/_react.default.createElement(_spinner.default, null);
    }
  }]);
  return MedicalChangeAmount;
}(_react.Component);
MedicalChangeAmount.propTypes = {
  maxPayeeCount: _propTypes.default.number,
  fetchOffersUrl: _propTypes.default.string,
  application: _propTypes.default.object,
  changePlanUrl: _propTypes.default.string,
  payees: _propTypes.default.object,
  user: _propTypes.default.object,
  addProvider: _propTypes.default.func,
  onCancel: _propTypes.default.func,
  removeProvider: _propTypes.default.func,
  constants: _propTypes.default.object,
  disclosureContent: _propTypes.default.object
};
MedicalChangeAmount.defaultProps = {
  maxPayeeCount: 1
};
var _default = {
  MedicalChangeAmount: MedicalChangeAmount,
  ChangeAmountEducator: _educator.default
};
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-revisions-v2/dist/pf-revisions.scss');